import { render, staticRenderFns } from "./certificate_PaotangVer.vue?vue&type=template&id=56aadc17&scoped=true"
import script from "./certificate_PaotangVer.vue?vue&type=script&lang=js"
export * from "./certificate_PaotangVer.vue?vue&type=script&lang=js"
import style0 from "./certificate_PaotangVer.vue?vue&type=style&index=0&id=56aadc17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56aadc17",
  null
  
)

export default component.exports